import { Component, Inject, OnInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';

@Component({
    selector: 'nphs-user-confirm-dialog',
    templateUrl: './confirm-dialog.component.html',
    styleUrls: ['./confirm-dialog.component.scss'],
    standalone: false
})
export class ConfirmDialogComponent implements OnInit {
  fromSharingItems: boolean;
  constructor(
    public dialogRef: MatDialogRef<ConfirmDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public dialogdata,
  ) { }

  ngOnInit(): void {
    this.fromSharingItems = false;
    this.fromSharingItems = this.dialogdata.fromSharingItems ? this.dialogdata.fromSharingItems : false;
  }

  title = this.dialogdata.title;
  message = this.dialogdata.message;
  isCancelNo=this.dialogdata.isCancelNo;
  isConfirmCancel=this.dialogdata.isConfirmCancel;
  isOk=this.dialogdata.isOk;
  isNoYes=this.dialogdata.isNoYes;
  dismissDialog = this.dialogdata.dismissDialog;
  isClose = this.dialogdata.isClose;

  action = {
    yes: { text: 'Yes' },
    no: { text: 'No' }
  };

  onYesClick() {
    this.closeDialog(true);
  }

  onNoClick() {
    this.closeDialog(false);
  }

  closeDialog(status: boolean) {
    this.dialogRef.close({ data: status });
  }

  onDismissDialog(status:string){
    this.dialogRef.close({data:status});  
  }
  

}
